import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00414004"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col py-4 px-6"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row space-x-4 justify-end items-end px-12"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add Section", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add Lesson", -1))
const _hoisted_5 = { class: "course-details relative flex flex-col-reverse md:flex-row py-1 gap-6" }
const _hoisted_6 = {
  key: 0,
  class: "w-full md:w-1/4 md:sticky md:top-6 flex flex-col bg-brand-card rounded-md px-2 py-4 h-auto md:h-[calc(92vh)] overflow-hidden"
}
const _hoisted_7 = { class: "text-[22px] font-bold" }
const _hoisted_8 = { class: "flex flex-1 flex-col space-y-4 h-full pt-6 overflow-y-scroll" }
const _hoisted_9 = { class: "flex flex-row pb-4 justify-between items-center" }
const _hoisted_10 = { class: "text-[20px] font-bold" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex flex-col space-y-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_15 = { class: "flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold" }
const _hoisted_16 = { class: "text-[14px] font-semibold" }
const _hoisted_17 = {
  key: 0,
  class: "text-[12px] font-bold uppercase px-1 py-0.5 rounded-md bg-green-400 bg-opacity-50"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "w-full md:w-3/4 flex flex-col space-y-6"
}
const _hoisted_20 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_21 = {
  key: 0,
  class: "flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold"
}
const _hoisted_22 = { class: "text-[22px] font-bold" }
const _hoisted_23 = {
  key: 0,
  class: "mx-auto w-full px-6 lg:px-8 aspect-video flex items-center justify-center bg-slate-800"
}
const _hoisted_24 = { class: "flex items-center justify-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "Pro", -1))
const _hoisted_26 = {
  key: 1,
  class: "responsive-iframe-container"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "hidden sm:flex shadow bg-brand-card rounded-xl px-6 py-3" }
const _hoisted_29 = { class: "inline-flex items-center" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-[12px] font-medium md:text-[15px]" }, "Mark Lesson Completed", -1))
const _hoisted_32 = { class: "hidden sm:flex shadow-lg bg-brand-card rounded-xl text-[18px] px-6 py-6" }
const _hoisted_33 = {
  key: 0,
  class: "font-medium"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }

import { useRoute } from 'vue-router'
import { useCoursesStore } from "@/stores/coursesStore";
import { computed, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { PlusIcon, PencilIcon } from "@heroicons/vue/24/outline";
import AddSectionDialog from "@/components/admin/AddSectionDialog.vue";
import AddLessonDialog from "@/components/admin/AddLessonDialog.vue";
import { useUserStore } from "@/stores/userStore";
import LoadingComponent from "@/components/LoadingComponent.vue";
import { SunIcon, MoonIcon, FireIcon } from '@heroicons/vue/24/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetailsPage',
  setup(__props) {

const route = useRoute()
const coursesStore = useCoursesStore()
const userStore = useUserStore()

const slug = route.params.slug as string
const index = parseInt(route.params.id as string || "0")

const selectedVideo = ref<Record<string, any> | null>(null)

const { course, courses, loading } = storeToRefs(coursesStore)
const { userState, plan, isAdmin, completedLessons } = storeToRefs(userStore)

let isPro = ref(false);

if (plan.value && plan.value?.expiry_date) {
  isPro.value = plan.value?.expiry_date.toDate() > new Date();
}

watch(plan, (newVal) => {
  loading.value = false;
  isPro.value = newVal?.expiry_date.toDate() > new Date();
});

if (userState) {
  coursesStore.fetchCourse(slug)
}

watch(userState, (newVal) => {
  if (newVal) {
    coursesStore.fetchCourse(slug)
  }
  console.log(userState.value);
});

const setSelectedVideo = (video: Record<string, any>) => {
  selectedVideo.value = video
}

const setVideo = () => {
  if (course?.value === null || course?.value === undefined) return
  let count = 0
  for (let i = 0; i < course?.value?.sections.length; i++) {
    const lessonsLength = course?.value?.sections[i].lessons.length
    count += lessonsLength
    if (count > index) {
      try {
        setSelectedVideo(course?.value?.sections[i].lessons[lessonsLength - (count - index)])
      } catch (e) {
        console.error(e)
      }
      break
    }
  }
}

watch(course, () => {
  setVideo();
})
setVideo();

const lessonCompleted = computed(() => {
  if (!userState.value) return false;
  if (!selectedVideo.value) return false;
  return completedLessons.value.includes(selectedVideo.value?.slug)
})

const onChangeLessonCompleted = (e: any) => {
  if (!userState.value) return;
  if (!selectedVideo.value) return;
  if (e.target.checked) {
    userStore.updateUserLesson(selectedVideo.value?.slug, true)
  } else {
    userStore.updateUserLesson(selectedVideo.value?.slug, false)
  }
}

const isAddSectionDialogOpen = ref(false)
const editSection = ref(null)
const openAddSectionDialog = () => {
  isAddSectionDialogOpen.value = true
}
const openEditSectionDialog = (section: any) => {
  editSection.value = section
  isAddSectionDialogOpen.value = true
}
const closeAddSectionDialog = () => {
  isAddSectionDialogOpen.value = false
  editSection.value = null
  editLesson.value = null
  coursesStore.fetchCourse(course.value?.slug);
}

const isAddLessonDialogOpen = ref(false)
const editLesson = ref(null)
const openAddLessonDialog = () => {
  isAddLessonDialogOpen.value = true
}
const openEditLessonDialog = (lesson: any, section: any) => {
  editLesson.value = lesson
  editSection.value = section
  isAddLessonDialogOpen.value = true
}
const closeAddLessonDialog = () => {
  isAddLessonDialogOpen.value = false
  editSection.value = null
  editLesson.value = null
  coursesStore.fetchCourse(course.value?.slug, true);
}

// Helper to find the index of the selected video within its section
const getSelectedVideoIndex = computed(() => {
  if (!course.value || !selectedVideo.value) return null;
  for (let i = 0; i < course.value.sections.length; i++) {
    const section = course.value.sections[i];
    const lessonIndex = section.lessons.findIndex(lesson => lesson.title === selectedVideo.value.title);
    if (lessonIndex !== -1) {
      return lessonIndex + 1; // Adding 1 to make it 1-based index
    }
  }
  return null;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(isAdmin))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  onClick: openAddSectionDialog,
                  class: "flex flex-row items-center text-white justify-center bg-brand-secondary px-6 py-2 rounded-xl hover:bg-brand-secondary-dark transition duration-300"
                }, [
                  _createVNode(_unref(PlusIcon), { class: "h-4 w-4" }),
                  _hoisted_3
                ]),
                _createElementVNode("button", {
                  onClick: openAddLessonDialog,
                  class: "flex flex-row items-center text-white justify-center bg-brand-secondary px-6 py-2 rounded-xl hover:bg-brand-secondary-dark transition duration-300"
                }, [
                  _createVNode(_unref(PlusIcon), { class: "h-4 w-4" }),
                  _hoisted_4
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_unref(course))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(course)?.title), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(course).sections, (section, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'section-' + index,
                        class: "flex flex-col"
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h2", _hoisted_10, _toDisplayString(section.title), 1),
                          (_unref(isAdmin))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: () => openEditSectionDialog(section),
                                class: "bg-brand-secondary text-white flex items-center p-2 rounded-full hover:bg-brand-secondary-dark transition duration-300"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                              ], 8, _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.lessons, (lesson, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'lesson-' + index,
                              onClick: () => setSelectedVideo(lesson),
                              class: _normalizeClass([{
                      'bg-brand-card-hover': selectedVideo.value?.title === lesson.title,
                  }, "flex flex-row px-2 space-x-2 justify-between py-2 items-center hover:bg-brand-card-hover rounded-md cursor-pointer transition duration-300"])
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(index + 1), 1),
                                _createElementVNode("p", _hoisted_16, _toDisplayString(lesson.title), 1),
                                (lesson.type.toLowerCase() == 'free')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(lesson.type), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(isAdmin))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: () => openEditLessonDialog(lesson, section),
                                    class: "bg-brand-secondary text-white flex items-center p-2 rounded-full hover:bg-brand-secondary-dark transition duration-300"
                                  }, [
                                    _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                  ], 8, _hoisted_18))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_13))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedVideo.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (getSelectedVideoIndex.value !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(getSelectedVideoIndex.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("h2", _hoisted_22, _toDisplayString(selectedVideo.value?.title), 1)
                  ]),
                  (!_unref(isPro) && !selectedVideo.value.videoUrl && !_unref(isAdmin))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_router_link, {
                            to: "/pro",
                            class: "font-bold text-5xl bg-gradient-to-r from-pink-500 to-yellow-500 text-white text-[16px] inline-flex items-center justify-center py-1.5 px-5 rounded-full transition-colors duration-300 hover:from-pink-600 hover:to-yellow-600"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FireIcon), { class: "h-8 w-8 mr-2" }),
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedVideo.value.videoUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("iframe", {
                          src: selectedVideo.value.videoUrl,
                          frameborder: "0",
                          allow: "autoplay; fullscreen; picture-in-picture; clipboard-write",
                          class: "responsive-iframe"
                        }, null, 8, _hoisted_27)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_29, [
                        _createElementVNode("input", {
                          class: "w-3 h-3 sm:w-4 sm:h-4",
                          onChange: onChangeLessonCompleted,
                          type: "checkbox",
                          checked: lessonCompleted.value
                        }, null, 40, _hoisted_30),
                        _hoisted_31
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (selectedVideo.value?.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(selectedVideo.value?.description), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (isAddSectionDialogOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(AddSectionDialog, {
                  "on-close": closeAddSectionDialog,
                  section: editSection.value
                }, null, 8, ["section"])
              ]))
            : _createCommentVNode("", true),
          (isAddLessonDialogOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(AddLessonDialog, {
                  "on-close": closeAddLessonDialog,
                  lesson: editLesson.value,
                  section: editSection.value
                }, null, 8, ["lesson", "section"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(loading))
      ? (_openBlock(), _createBlock(LoadingComponent, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})